import { Client, InitialConfig, OtpGeneration, OtpValidation } from './../interfaces/interfaces';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, map } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { INITIAL_CONFIG } from '../config/initial-config';

@Injectable({
  providedIn: 'root'
})
export class OtpService {
  public attemptSequence!: string;
  public errorMsg: string = "El proceso no ha podido finalizar.";
  public client!: Client;
  public areLinksDisabled: boolean = false;
  private isValidOtp!: boolean;
  private otpGenerated = false;
  private otpSubmitted = false;
  private http = inject(HttpClient);
  private router = inject(Router);
  private initialConfig: InitialConfig = inject(INITIAL_CONFIG);

  constructor(){
    console.log(this.initialConfig)
  }

  isOtpSubmitted() {
    return this.otpSubmitted;
  }

  isOtpGenerated() {
    return this.otpGenerated;
  }

  getAttemptSequence(): string {
    return this.attemptSequence;
  }

  setAttemptSequence(sequence: string) {
    this.attemptSequence = sequence;
    localStorage.setItem("attemptSequence", sequence);
  }

  getIsValidOtp(): boolean {
    return this.isValidOtp;
  }

  getInitialConfig(): InitialConfig{
    return this.initialConfig;
  }

  setIsValidOtp(isValid: boolean) {
    this.isValidOtp = isValid;
    localStorage.setItem('isValidOtp', isValid.toString());
  }

  generateOtp() {
    this.otpGenerated = true;
    localStorage.setItem("otpGenerated", "true");
  }

  resetTokenizationProps() {
    this.otpGenerated = false;
    this.isValidOtp = false;
    this.otpSubmitted = false;
    localStorage.setItem("isValidOtp", "false");
    localStorage.setItem("otpGenerated", "false");
    localStorage.setItem("otpSubmitted", "false");
  }

  getLocale(): string {
    return this.initialConfig.country;
  }

  submitOtp(isOtpSubmitted: boolean) {
    this.otpSubmitted = isOtpSubmitted;
    localStorage.setItem("otpSubmitted", isOtpSubmitted.toString());
  }

  setClient(client: Client) {
    this.client = client;
    localStorage.setItem("client", JSON.stringify(client));
  }

  loadCachedClient() {
    const clientData = localStorage.getItem("client");
    if (clientData) {
      this.client = JSON.parse(clientData);
    }
    return this.client;
  }

  getClientInfo() {
    const httpHeaders: HttpHeaders = new HttpHeaders({
      Authorization: this.initialConfig.token || localStorage.getItem('token') as string,
    });

    return this.http.get<Client>(`${environment.baseUrl}${environment.endpoints.TOKENIZATION.client}`, { headers: httpHeaders })
      .pipe(
        map(response => {
          this.setClient(response);
          return this.loadCachedClient();
        }),
        catchError(({error}) => {
          if(error.resultCode === "1005" || error.resultCode === "1006") {
            this.errorMsg = "El identificador es inválido o ha expirado.";
          }
          return this.router.navigate(['/process-error']);
        })
      )
  }

  //gen OTP
  getOtp() {
    const httpHeaders: HttpHeaders = new HttpHeaders({
      Authorization: this.initialConfig.token || localStorage.getItem('token') as string,
    });

    this.areLinksDisabled = true;
    
    return this.http.post<OtpGeneration>(`${environment.baseUrl}${environment.endpoints.OTP.otp}`, [], { headers: httpHeaders })
      .pipe(
        catchError(() => {
          this.router.navigate(['/process-error']);
          return EMPTY;
        } )
      )
      .subscribe(({ attemptSequence }) => {
        this.generateOtp();
        this.setAttemptSequence(attemptSequence);
        this.areLinksDisabled = false;
        this.router.navigate(['/otp']);
      });
  }

  //Valida OTP
  postOtp(otp: string) {
    console.log(otp)
    const httpHeaders: HttpHeaders = new HttpHeaders({
      Authorization: this.initialConfig.token || localStorage.getItem('token') as string,
    });
    
    this.http.post<OtpValidation>(`${environment.baseUrl}${environment.endpoints.OTP.validation}`, { otp_code: otp }, { headers: httpHeaders })
      .pipe(
        catchError(() => {
          this.submitOtp(true);
          this.setIsValidOtp(false);
          console.log(this.isValidOtp)
          return EMPTY;
        })
      )
      .subscribe(response => {
        if(response?.result) {
          this.submitOtp(true);
          this.setIsValidOtp(true);
          this.router.navigate(['/process-checkout']);
        }
      });
  }
}
